<template>
  <div>
    <div v-if="$auth.can({statistics: 'read'}, 'permissions')">
      <performance-chart v-if="showPerformanceChart === 'true'"/>
      <div class="row">
        <div class="col-lg-4 col-md-4" v-if="showAccountsCount === 'true' && $auth.can({accounts_statistics: 'read'}, 'permissions')">
          <accounts-count-stats-card/>
        </div>
        <div class="col-lg-4 col-md-4"  v-if="showTopUpSums === 'true'">
          <top-up-sums-stats-card/>
        </div>
        <div class="col-lg-4 col-md-4" v-if="$auth.can({inspector_team: 'read'}, 'permissions') && $auth.can({pt_lock: 'read'}, 'permissions')">
          <inspector-teams-stats-card/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import PerformanceChart from './PerformanceChart';
  import AccountsCountStatsCard from 'src/pages/Accounts/AccountsCountStatsCard';
  import TopUpSumsStatsCard from 'src/pages/Topups/TopUpSumsStatsCard';
  import InspectorTeamsStatsCard from 'src/pages/InspectorTeams/InspectorTeamsStatsCard';


  export default {
    name: 'starter-page',
    components: {
      PerformanceChart,
      AccountsCountStatsCard,
      TopUpSumsStatsCard,
      InspectorTeamsStatsCard,
    },
    data() {
      return {
        showPerformanceChart: process.env.VUE_APP_STARTER_VIEW_SHOW_PERFORMANCE_CHART,
        showAccountsCount: process.env.VUE_APP_STARTER_VIEW_SHOW_ACCOUNTS_COUNT,
        showTopUpSums: process.env.VUE_APP_STARTER_VIEW_SHOW_TOP_UP_SUMS,
      };
    },
  };
</script>
